<template>
  <skud-passage-list />
</template>

<script>
import SkudPassageList from '@/views/skud/components/SkudPassageList.vue'

export default {
  name: 'SkudPassageListPage',
  components: { SkudPassageList }
}
</script>
